import { useAal } from './useAal';
import { useSupabaseUser } from './useSupabaseUser';

/**
 * Composable that returns the Supabase user only if their AAL level is sufficient (no step-up required).
 * Returns null otherwise.
 */
export const useVerifiedSupabaseUser = () => {
	const user = useSupabaseUser();

	const { isVerified } = useAal();

	const verifiedUser = computed(() => isVerified.value ? user.value : null);

	return verifiedUser;
};
